import useSWR from "swr";
import { useSWRFetcher } from "./useSWRFetcher";
import { NominalCodeModel } from "@attelas/shared";
import { environment } from "../config/environment";

export const useNominalCodes = (businessTenantId?: string | null) => {
  const fetcher = useSWRFetcher();

  const { data, isLoading, error } = useSWR<NominalCodeModel[]>(
    `${environment.apiUrl}/api/invoices/nominal-codes`,
    (url: string) => {
      if (businessTenantId) {
        return fetcher(url, { headers: { "Business-Tenant": businessTenantId } });
      }
      return fetcher(url);
    },
    {}
  );

  return {
    nominalCodes: data,
    isLoading,
    error,
  };
};
